import styled from 'styled-components';
export const Container = styled.div`
    display: flex;
    width: 100%;
    flex: 1;
    padding: 2rem;
    padding-bottom: 0;
    gap: .75rem;
    background: #f3f4f6;
    flex-direction: column;
    overflow: auto;
    &::-webkit-scrollbar{
      width: 5px;
      height: 5px;
    }
    &::-webkit-scrollbar-thumb{
      background-color: rgb(0, 0, 0,0.2);
    }
    .disabled{
      pointer-events: none;
      opacity: 0.7;
    }
    .column{
      display: flex;
      width: 100%;
      align-items: center;
      gap: 1rem;
      font-weight: 400;
    }
`;
export const BoxSelect = styled.div`
  display: flex;
  width: 90%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1rem;
  .box--{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 1rem;
    .line-{
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      gap: 1rem;
      justify-content: space-between;
      .date{
        width: 10rem;
        border: 1px solid #1D86FF;
        background-color: transparent;
      }
    }
  }
  .list-{
    width: 20rem;
  }
  
`;
export const BtnSearch = styled.button`
    outline: none;
    border: none;
    display: flex;
    width: 3rem;
    height: 2.5rem;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    cursor: pointer;
    color: #ffffff;
    background-color: #1D86FF;
    font-size: 1.5rem;

    .loader{
      display: flex;
      border: 2px solid #ffffff;
      border-radius: 50%;
      border-top: 2px solid #1d83e2;
      width: 2rem;
      height: 2rem;
      animation: spin 1.5s linear infinite;
    }
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
`;
export const Content = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  flex-direction: column;
  .area--cards{
    display: flex;
    width: 100%;
    gap: 0.75rem;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 1rem;
  }
  .area--table{
    display: flex;
    width: 100%;
    flex: 1;
    margin-top: 1rem;
    background-color: #ffffff;
    border-radius: 4px;
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
  }
`;
export const Card = styled.div`
    position: relative;
    margin-top: 0.75rem;
    display: flex;
    width:  ${({ width }) => width};
    height: ${({ height }) => height};
    border-radius: 4px;
    padding: 1.3rem;
    background-color: #ffffff;
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
    border-left: 3px solid #1D86FF;
    .icon--{
        position: absolute;
        display: flex;
        width: 4.5rem;
        height: 4.5rem;
        top: -15px;
        background-color: blue;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        font-size: 1.5rem;
        color: #ffff;
        background-color: #1D86FF;
        box-shadow: rgb(0 0 0 / 20%) 0px 2px 1px -1px, rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 1px 3px 0px;

    }
    .info--{
        display: flex;
        width: 100%;
        height: auto;
        margin-left: 4.5rem;
        flex-direction: column;
        gap: 0.5rem;

        .title--{
            display: flex;
            width: 100%;
            height: 1rem;
            font-size: 1rem;
            font-weight: 100;
            justify-content: right;
            align-items: center;
        }
        .value{
            font-size: 1.5rem;
            font-weight: bolder;
            justify-content: right;
            align-items: center;
        }
    }

`;
export const Table = styled.div`
  display: flex;
  width: 100%;
  height: 100%; 
  max-height: 100%;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  background-color: #fff;

  .area--users {
    flex: 1;
    display: flex;
    flex-direction: column;
    /* border-right: 1px solid rgba(0, 0, 0, 0.08); */
    background-color: #fafafa;
    overflow-y: auto;
    max-height: 60vh;
  }

  .area--users span {
    display: flex;
    padding: 1rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    cursor: pointer;
    transition: all 0.2s ease;
    justify-content: start;
    align-items: center;
    font-size: 0.95rem;
    color: #333;
    min-height: 3rem;
    /* white-space: nowrap; */
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .area--users span:hover {
    background-color: #f1f1f1;
  }

  .area--users span.active {
    background-color: #ffffff;
    font-weight: 600;
  }

  .area--information {
    flex: 3;
    display: flex;
    flex-direction: column;
    padding: 1.5rem;
    overflow-y: scroll; 
    max-height: 100%;
  }

  .placeholder-- {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    color: #888;
    font-style: italic;
  }

  .header-- {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .header-- .info--user {
    display: flex;
    flex-direction: column;
    margin-bottom: 0.5rem;
    gap: 0.25rem;
  }

  .header-- strong {
    font-size: 1.1rem;
    color: #222;
  }

  .header-- span {
    font-size: 0.9rem;
    color: #555;
  }

  .icon-- {
    display: flex;
    justify-content: end;
    color: #ff2a2a;
    font-size: 1.8rem;
    margin-bottom: 0.5rem;
    cursor: pointer;
  }

  .list--attendances {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    max-height: 47vh;
    overflow-y: scroll;
  }

  .details--item {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    /* background-color: #f9f9f9; */
    padding: 0.8rem 1rem;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
    /* transition: transform 0.2s ease, box-shadow 0.2s ease; */
  }

  .details--item strong {
    color: #333;
  }

  .details--item div {
    font-size: 0.9rem;
    color: #555;
  }

  .area--users::-webkit-scrollbar,
  .area--information::-webkit-scrollbar {
    width: 6px;
  }

  .area--users::-webkit-scrollbar-thumb,
  .area--information::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }
`;